import PopupBasic from 'src/game/components/popups/PopupBasic';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { AssetGroup } from '@play-co/timestep-core';
import i18n from 'src/lib/i18n/i18n';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { BuddiesJoinRewards } from 'src/game/buddies/components/BuddiesJoinRewards';
import { BuddiesPlayerInfo } from 'src/game/buddies/components/BuddiesPlayerInfo';
import ConfettiOverlay from 'src/game/minigame/match2-timestep/components/ConfettiOverlay';

type CloseHandler = (ok: boolean) => void;

export default class PopupBuddiesJoinRewards extends PopupBasic {
  private playerInfo: BuddiesPlayerInfo;
  private confetti: ConfettiOverlay;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      superview: opts.superview,
      zIndex: 10000,
      width: uiConfig.popups.buruburu.width,
      height: 700,
      darkerBg: false,
      close: () => {
        opts.close(false);
      },
      tracking: {
        feature: Feature.BUDDIES._,
        $subFeature: Feature.BUDDIES.POPUP_INFO,
      },
    });

    this.confetti = new ConfettiOverlay({
      superview: this.getView(),
    });
    this.box.updateOpts({
      zIndex: 1,
    });

    const content = new FlexBoxView({
      superview: this.box,
      flex: {
        width: this.box.style.width,
        height: this.box.style.height,
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 80,
      },
    });

    // Subtitle
    new LangBitmapFontTextView({
      superview: content,
      align: 'center',
      verticalAlign: 'center',
      size: 26,
      font: 'Body',
      color: '#BF8147',
      width: this.box.style.width - 80,
      height: 40,
      localeText: () => i18n('match2.buddies.joinRewardsPopup.subtitle'),
    });

    this.playerInfo = new BuddiesPlayerInfo({
      superview: content,
    });

    // Rewards section (ribbon + powerups + message)
    new BuddiesJoinRewards({
      superview: content,
      width: this.box.style.width,
    });

    // Continue button
    const buttonRow = new FlexBoxView({
      superview: content,
      flex: {
        width: this.box.style.width - 40,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 15,
      },
    });

    new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: buttonRow,
      width: 230,
      height: 90,
      labelOffsetX: -5,
      labelOffsetY: -1,
      fontSize: 38,
      font: 'Body' as const,
      centerOnOrigin: false,
      localeText: () => i18n('match2.buddies.joinRewardsPopup.continue'),
      onClick: async () => {
        sounds.sfx.play('ok');
        opts.close(true);
      },
      tracking: {
        feature: Feature.BUDDIES._,
        $subFeature: Feature.BUDDIES.BUTTON_COLLECT,
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup(
      AssetGroup.constructURLs(['assets/ui/buddies/common']),
    );
  }

  public init(args: { name: string; photo: string }) {
    super.init({
      title: i18n('match2.buddies.joinRewardsPopup.title'),
    });

    this.playerInfo.setPlayer({ name: args.name, photo: args.photo });
  }

  public async fadeIn() {
    await super.fadeIn();
    this.confetti.show();
    sounds.playSound('win');
    sounds.playSound('applause');
  }

  public fadeOut() {
    this.confetti.hide();
    super.fadeOut();
  }
}
